<script setup>
import useEuSign from '@/components/modal/EuSign/hooks/useEuSign';
import SignDialogBase from '@/components/modal/EuSign/SignDialogBase';

const props = defineProps({
  active: {type: Boolean, required: true},
  title: {type: String, default: 'Підпис об\'єкта'},
  data: {type: [Object, String], required: true},
});
const emit = defineEmits(['update:active', 'sign']);
const {signWidget, euSign, destroyWidget} = useEuSign(signData, props);

/**
 * @param {boolean} event
 */
const onHide = (event) => {
  emit('update:active', event);
  destroyWidget();
};

async function signData() {
  const data = typeof props.data === 'string' ? props.data : JSON.stringify(props.data);
  const previousSign = null;
  const external = false;
  const asBase64String = true;
  const signAlgo = signWidget.EndUser.SignAlgo.DSTU4145WithGOST34311;
  const signType = signWidget.EndUser.SignType.CAdES_X_Long;
  try {
    const sign = await euSign.value.SignData(data, external, asBase64String, signAlgo, previousSign, signType);
    if (sign) {
      onHide(false);
      emit('sign', sign);
    }
  } catch(e) {
    console.error(`Виникла помилка при підписі даних. Опис помилки: ${(e.message || e)}`);
  }
}
</script>

<template>
  <SignDialogBase
    :active="active"
    :title="title"
    @update:active="onHide"
  />
</template>
